/**
 * ตัด trailing ".0" ของรหัสตัวเลขที่หลุดมาจาก Excel/float (เช่น "1014.0" → "1014")
 * โดยไม่แตะรหัสตัวอักษรหรือทศนิยมจริง ("ACT-88231", "1014.5", "1.2.6")
 *
 * defense ชั้น UI (user request 2026-08-31): ข้อมูล prod ล้างแล้ว + ทางเข้า import อุดแล้ว (50fd416)
 * แต่คงเกราะไว้เผื่อค่าสกปรกหลุดเข้ามาทางอื่นในอนาคต — helper กลางแทน copy ประจำหน้า (เดิมมี 3 ก็อปปี้)
 */
export const formatActivationCode = (v?: string | null): string => {
  const t = (v ?? '').trim();
  return /^\d+\.0+$/.test(t) ? t.split('.')[0] : t;
};
